import { ChakraProvider, Switch, useToast } from '@chakra-ui/react';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { DashboardHooks, useToggleBannerMutation } from '@partiu/api/dashboard/hooks.ts';
import { useMemo } from 'react';
import { IBanner } from '@partiu/api/types';
import { useQueryClient } from 'react-query';

export function ToggleBannerSwitch({ value, banner }: { value: number[]; banner: IBanner }) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { id } = useTheme();
  const checked = useMemo(() => {
    return !value?.includes(id as number);
  }, [value]);
  const mutation = useToggleBannerMutation({
    onSuccess() {
      toast({
        title: 'Sucesso',
        description: `Banner ${checked ? 'desativado' : 'ativado'} com sucesso`,
        status: 'success',
      });
      queryClient.invalidateQueries(DashboardHooks.Banners).then();
    },
    onError() {
      toast({
        title: 'Erro',
        description: `Não foi possivel ${
          checked ? 'desativar' : 'ativar'
        } o banner. Tente novamente mais tarde ou entre em contato com o suporte em suporte@partiu.com.br`,
        status: 'error',
      });
    },
  });

  return (
    <ChakraProvider>
      <Switch
        onChange={() => mutation.mutate(banner.id)}
        disabled={mutation.isLoading}
        isChecked={checked}
        size={'md'}
      />
    </ChakraProvider>
  );
}
